import { initializeRadioButtons } from '../utilities/radioUncheck';

export default ($) => {
  const INITIAL_VISIBLE_ITEMS = 10000;
  const LOAD_MORE_INCREMENT = 2;

  const initialParams = new URLSearchParams(window.location.search);

  const $filterForms = $('.js-filterForm');
  const $filterResults = $('.js-filterResults');

  if (!$filterForms.length || !$filterResults.length) return;

  $filterForms.each(function () {
    const $filterForm = $(this);

    const $filters = $filterForm.find('select, input[type=radio], input[type=checkbox]');
    const $filterSearch = $filterForm.find('input[name=search]');
    const $resetBtn = $filterForm.find('.js-filterReset');
    const $loadMoreBtn = $filterResults.find('.js-loadMore');
    const $filterItems = $filterResults.find('.js-filterItem');
    const facultyStaffFilter = $('.js-toggleSpecificFilter');
    const specificFilter = $('.js-specificFilter');

    $loadMoreBtn.hide(); // Temp hiding cause we show all results.

    let _filters = [];
    let visibleItems = INITIAL_VISIBLE_ITEMS;

    const NO_RESULTS_HTML = `
      <div class="_subhead no-results-message">
        No results. Try adapting or resetting filters.
      </div>
    `;

    let resetFilters = () => {
      const cleanUrl = window.location.origin + window.location.pathname;

      window.location.href = cleanUrl;
    };

    const initializeFiltersFromURL = () => {
      _filters = [];

      // First collect all values for each parameter (handling arrays)
      const paramMap = new Map();
      initialParams.forEach((value, name) => {
        if (value && value !== "") {
          if (!paramMap.has(name)) {
            paramMap.set(name, []);
          }
          paramMap.get(name).push(value);
        }
      });

      // Convert to filters (arrays for checkboxes, single values for others)
      paramMap.forEach((values, name) => {
        const $filter = $(`[name="${name}"]`).first();
        if ($filter.is(':checkbox')) {
          // For checkboxes, store as array
          _filters.push({ name, value: values });
        } else {
          // For other inputs, take the first value
          _filters.push({ name, value: values[0] });
        }
      });

      // Update form controls
      $filters.each(function() {
        const $filter = $(this);
        const name = $filter.attr('name');
        const matchingFilter = _filters.find(filter => filter.name === name);

        if (matchingFilter) {
          if ($filter.is('select')) {
            $filter.val(matchingFilter.value);
          } else if ($filter.is(':radio')) {
            $filter.prop('checked', $filter.val() === matchingFilter.value);
          } else if ($filter.is(':checkbox')) {
            // For checkboxes, check if this value is in the array
            $filter.prop('checked', matchingFilter.value.includes($filter.val()));
          }
        }
      });

      // Handle search separately if needed
      const searchFilter = _filters.find(filter => filter.name === $filterSearch.attr('name'));
      if (searchFilter) {
        $filterSearch.val(searchFilter.value);
      }
    };

    initializeFiltersFromURL();

    const updateQueryParams = () => {
      const params = new URLSearchParams();

      _filters.forEach(filter => {
        if (filter.value) {
          if (Array.isArray(filter.value)) {
            // For arrays (checkboxes), add each value separately
            filter.value.forEach(val => {
              params.append(filter.name, val);
            });
          } else {
            // For single values
            params.set(filter.name, filter.value);
          }
        }
      });

      if (params.toString()) {
        history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);
      } else {
        history.replaceState(null, '', window.location.pathname);
      }
    };

    const updateFilterState = ($filter) => {
      const name = $filter.attr('name');
      const isCheckboxOrRadio = $filter.is(':checkbox, :radio');

      if (isCheckboxOrRadio) {
        // Handle checkbox/radio - get all checked values with this name
        const checkedValues = $(`[name="${name}"]:checked`).map(function() {
          return $(this).val();
        }).get();

        // Remove existing entry for this filter name
        _filters = _filters.filter(f => f.name !== name);

        // If there are checked values, add them as an array
        if (checkedValues.length > 0) {
          _filters.push({ name, value: checkedValues });
        }
      } else {
        // Handle other inputs (non-checkbox/radio) as before
        const value = $filter.val();

        _filters = _filters.filter(f => f.name !== name);

        if (value && value !== '') {
          _filters.push({ name, value });
        }
      }

      // console.log('_filters', _filters);
    };

    const applyFilters = () => {
      let totalMatchingCount = 0; // Track the number of items that match filters
      let visibleCount = 0;       // Count items we are showing

      // Remove any existing 'No Results' message
      $filterResults.find('.no-results-message').remove();

      $filterItems.each(function () {
        const $item = $(this);
        let matches = true;

        // Check filters other than search
        _filters.forEach(filter => {
          if (filter.name !== 'search') {
            if (Array.isArray(filter.value)) {
              // Handle checkbox filters (array of values)
              let hasAnyClass = false;
              filter.value.forEach(val => {
                if ($item.hasClass(val)) {
                  hasAnyClass = true;
                }
              });
              if (!hasAnyClass) {
                matches = false;
              }
            } else {
              // Handle regular filters (single value)
              if (!$item.hasClass(filter.value)) {
                matches = false;
              }
            }
          }
        });

        // Check search filter
        const searchFilter = _filters.find(filter => filter.name === 'search');
        if (searchFilter) {
          const searchValue = searchFilter.value.toLowerCase();
          const itemText = $item.text().toLowerCase();
          if (!itemText.includes(searchValue)) {
            matches = false;
          }
        }

        // Count total matching items
        if (matches) {
          totalMatchingCount++;

          if (visibleCount < visibleItems) {
            $item.show();
            visibleCount++;
          } else {
            $item.hide();
          }
        } else {
          $item.hide();
        }
      });

      if (totalMatchingCount === 0) {
        $filterResults.append(NO_RESULTS_HTML);
        $loadMoreBtn.hide();
      } else {
        if (visibleCount < totalMatchingCount) {
          $loadMoreBtn.show();
        } else {
          $loadMoreBtn.hide();
        }
      }

      updateQueryParams();
    };

    applyFilters();

    $loadMoreBtn.on('click', function () {
      visibleItems += LOAD_MORE_INCREMENT;
      applyFilters();
    });

    $filters.on('change', function () {
      updateFilterState($(this));
      applyFilters();
    });

    $filterSearch.on('input cut change keyup blur', function () {
      updateFilterState($(this));
      applyFilters();
    });

    $resetBtn.on('click', function (e) {
      e.preventDefault();
      resetFilters();
    });

    facultyStaffFilter.on('change', function () {
      let $_this = $(this);
      let $thisData = $_this.val();

      specificFilter.hide().each(function () {
        let $firstDisabledLi = $(this).find('li.disabled').first();

        if ($firstDisabledLi.length) {
          $firstDisabledLi.trigger('click');
        }
      });

      if (!$thisData) return;
      specificFilter.filter(`[data-specific="${$thisData}"]`).show();
    });

    let $selectedFilter = facultyStaffFilter.filter(':checked');

    if ($selectedFilter.length) {
      let $thisData = $selectedFilter.val();

      specificFilter.filter(`[data-specific="${$thisData}"]`).show();
    }
  });
};